import React, { useState, useRef, useEffect } from "react";
import styled from "@xstyled/styled-components";
import { tokens } from "../utils/theme";

const SelectWrapper = styled.div`
  position: relative;
  font-size: 11px;
  color: ${props => tokens(props.theme.palette.mode).grey[400]};
`;

const SelectTrigger = styled.div`
  background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(19, 22, 35, 0.98)' : 'rgba(255, 255, 255, 0.78)'};
  border-radius: 999px;
  border: 1px solid ${props => props.theme.palette.mode === 'dark' ? '#252a3e' : tokens(props.theme.palette.mode).grey[500]};
  padding: 4px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 120px;
  justify-content: space-between;
  transition: all 0.2s;

  &:hover {
    border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.5)' : 'rgba(15,118,110,0.35)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#e0e0e0' : tokens(props.theme.palette.mode).grey[100]};
  }
`;

const SelectMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(19, 22, 35, 0.98)' : 'rgba(255, 255, 255, 0.98)'};
  border: 1px solid ${props => props.theme.palette.mode === 'dark' ? '#252a3e' : tokens(props.theme.palette.mode).grey[500]};
  border-radius: 12px;
  padding: 4px;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const SelectOption = styled.div`
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.1s;
  color: ${props => props.selected
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : (props.theme.palette.mode === 'dark' ? '#b0bec5' : tokens(props.theme.palette.mode).grey[400])};
  background: ${props => props.selected
        ? (props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.1)' : 'rgba(15,118,110,0.08)')
        : 'transparent'};

  &:hover {
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#e0e0e0' : tokens(props.theme.palette.mode).grey[100]};
  }
`;

const CustomSelect = ({ value, onChange, options }) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <SelectWrapper ref={wrapperRef}>
            <SelectTrigger onClick={() => setIsOpen(!isOpen)}>
                {value}
                <span style={{ fontSize: '8px', opacity: 0.7 }}>▼</span>
            </SelectTrigger>
            {isOpen && (
                <SelectMenu>
                    {options.map(option => (
                        <SelectOption
                            key={option}
                            selected={value === option}
                            onClick={() => {
                                onChange(option);
                                setIsOpen(false);
                            }}
                        >
                            {option}
                        </SelectOption>
                    ))}
                </SelectMenu>
            )}
        </SelectWrapper>
    );
};

export default CustomSelect;
